import { styled, css } from 'styled-components';
import RegionsRenderer from '../renderers/RegionsRenderer';

const FullWidthPageType = ({ page: { regions } }) => {
  const hasT2PremiumNavigationPadding = !!regions
    ?.find((element) => element.id === 'Main')
    ?.fragments?.find(
      (element) =>
        element?.template?.id === 'PartnerHeader' ||
        element?.template?.id === 'ContentHeader' ||
        element?.template?.id === 'T2Navigation' ||
        element?.template?.id === 'StaffListing' ||
        element?.template?.id === 'ArticleListing',
    );

  if (regions) {
    return (
      <Container>
        <SiteContent>
          <SiteHeader
            hasAHeader={hasHeader(regions)}
            hasContentHeader={hasT2PremiumNavigationPadding}
          >
            <RegionsRenderer
              data={regions}
              regions={['HeaderRegion', 'Header']}
              key="HeaderRegion"
            />
          </SiteHeader>
          <RegionsRenderer
            data={regions}
            regions={['MainRegion', 'Main', 'Hero', 'Bottom']}
            key="MainRegion"
          />
        </SiteContent>
        <SiteFooter>
          <RegionsRenderer data={regions} regions={['FooterRegion', 'Footer']} key="FooterRegion" />
        </SiteFooter>
      </Container>
    );
  }
};

export default FullWidthPageType;

const Container = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: space-between;
`;

const SiteHeader = styled.div`
  ${({ theme, hasAHeader }) => css`
    ${!hasAHeader ? 'padding-top: 60px;' : ``};
    ${!hasAHeader && theme.style.navigation.variant === 'b' ? 'padding-top: 100px;' : ``};
  `}
`;

const SiteContent = styled.div`
  flex: 1 0 auto;
`;

const SiteFooter = styled.div`
  justify-self: flex-end;
`;

function hasHeader(regions) {
  // Check if there is a Header Component in the Main Region of the page
  const hasAHeader = !!regions
    ?.find((element) => element.id === 'Main')
    ?.fragments?.find(
      (element) =>
        element?.template?.id === 'PartnerHeader' ||
        element?.template?.id === 'HomepageHeader' ||
        element?.template?.id === 'ContentHeader' ||
        element?.template?.id === 'T2Navigation',
    );

  // Check if there is a T2Navigation in the Header Main Region
  const hasHeaderT2 = !!regions
    ?.find((element) => element.id === 'Header')
    ?.regions?.find((element) => element.id === 'Main')
    ?.fragments?.find((element) => element?.template?.id === 'T2Navigation');

  // Check if there is a T2Navigation in the Header directly
  const hasHeaderT2Article = !!regions
    ?.find((element) => element.id === 'Header')
    ?.fragments?.find((element) => element?.template?.id === 'T2Navigation');

  return hasAHeader || hasHeaderT2 || hasHeaderT2Article;
}
